<main @fade>
  <form [formGroup]="form" (ngSubmit)="chooseCategory()" [nbSpinner]="loading">
    <nb-card>
      <nb-card-body>
        <p>
          <ng-select [items]="categories"
                     [virtualScroll]="true"
                     (scroll)="onScroll($event)"
                     (scrollToEnd)="onScrollToEnd()"
                     [minTermLength]="2"
                     size="small"
                     [compareWith]="compareCategories"
                     [loading]="loadingCategories"
                     [typeahead]="catalogInput$"
                     [clearable]="true"
                     (clear)="clearSearch()"
                     (change)="changeSelectedCatalog($event)"
                     formControlName="category"
                     typeToSearchText="Пожалуйста, введите 2 или более символов"
                     i18n-typeToSearchText="@@TemplateAutocompleteTypeToSearchText"
                     placeholder="Введите название категории"
                     i18n-placeholder="@@CatalogAutocompleteLabel"
          >
            <ng-template ng-header-tmp>
              <small class="form-text text-muted">Загружено {{ loadedElements }} из {{ totalElements }}</small>
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              {{ getOptionLabel(item) }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div>{{ getOptionLabel(item) }}</div>
            </ng-template>
          </ng-select>
        </p>

        <div class="chosenCatalogs" *ngIf="fullChosenCatalogs && fullChosenCatalogs.length > 0">
          <div *ngFor="let catalog of fullChosenCatalogs">
            {{ getOptionLabel(catalog) }}
            <button i18n-nbTooltip="@@Delete" nbTooltip="удалить" status="danger" (click)="removeCatalog(catalog)" type="button" nbButton size="tiny">
              <nb-icon icon="close"></nb-icon>
            </button>
          </div>
        </div>

        <div class="category">
          <div class="cascader-table-root">
            <div class="cascader-table-row">

              <ul class="cascader-table-column" *ngFor="let categoryLevel of categoriesByLevels">
                <li class="cascader-table-category" *ngFor="let category of categoryLevel" (click)="chooseCascadeCategory(category)" [ngClass]="{active: isActive(category)}">
                  <span class="header">{{ category.header }}</span>
                  <nb-icon class="cascader-table-categoryHasChildIcon" *ngIf="!category.lastLevel" icon="arrow-ios-forward-outline"></nb-icon>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nb-card-body>

      <nb-card-footer>
        <button nbButton [disabled]="form.invalid || !isCategoryLevelAppropriate()" type="submit" status="primary" i18n="@@ChooseCategoryButton">Выбрать</button>
      </nb-card-footer>
    </nb-card>
  </form>
</main>

